















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { requiredRule } from '@/helpers/validation'
import range from '@/helpers/range'
import months from '@/helpers/months'

@Component
export default class StepForm extends Vue {
  @Prop(Number) caseCount!: number
  @Prop(Number) startYear!: number
  @Prop(Number) year!: number
  @Prop(Number) month!: number
  @Prop(String) stepKey!: string
  @Prop(String) stepLabel!: string

  readonly months = months
  get years() {
    return range(this.startYear, 2020)
  }

  get requiredRules() {
    return [requiredRule]
  }

  get selectedYear() {
    return this.year
  }
  set selectedYear(value) {
    this.$emit('updateSurveyData', this.stepKey, { year: value })
  }

  get selectedMonth() {
    return this.month
  }
  set selectedMonth(value) {
    this.$emit('updateSurveyData', this.stepKey, { month: value })
  }

  get selectedCaseCount() {
    return this.caseCount
  }
  set selectedCaseCount(value) {
    this.$emit('updateSurveyData', this.stepKey, { caseCount: value })
  }
}
